import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Sparkles, X, Maximize2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import AIAssistant from './AIAssistant';

/**
 * AIAssistantBubble — floating chat launcher visible on every page for admins.
 *
 * Hides itself when:
 *   - the user is not an admin
 *   - we're on auth pages (login/register/reset)
 *   - we're already on the dedicated /ai-assistant page
 */
export default function AIAssistantBubble() {
  const { user } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  if (!user || !user.is_admin) return null;
  const path = location.pathname;
  if (
    path.startsWith('/login') ||
    path.startsWith('/register') ||
    path.startsWith('/forgot-password') ||
    path.startsWith('/reset-password') ||
    path.startsWith('/ai-assistant') ||
    path === '/'
  ) {
    return null;
  }

  return (
    <>
      {/* Floating launcher button */}
      {!open && (
        <button
          onClick={() => setOpen(true)}
          className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white shadow-2xl hover:scale-105 active:scale-95 transition-transform flex items-center justify-center"
          title="Open AI Copilot"
          data-testid="ai-bubble-launcher"
        >
          <Sparkles size={22} />
        </button>
      )}

      {/* Floating chat panel */}
      {open && (
        <div
          className="fixed bottom-6 right-6 z-50 w-[380px] max-w-[calc(100vw-2rem)] h-[600px] max-h-[calc(100vh-3rem)] bg-white rounded-2xl shadow-2xl border border-slate-200 flex flex-col overflow-hidden"
          data-testid="ai-bubble-panel"
        >
          <div className="absolute top-2 right-2 z-10 flex gap-1">
            <a
              href="/ai-assistant"
              title="Open full page"
              className="w-7 h-7 rounded-md bg-white/90 backdrop-blur hover:bg-slate-100 flex items-center justify-center text-slate-600"
              data-testid="ai-bubble-expand"
            >
              <Maximize2 size={14} />
            </a>
            <button
              onClick={() => setOpen(false)}
              title="Close"
              className="w-7 h-7 rounded-md bg-white/90 backdrop-blur hover:bg-slate-100 flex items-center justify-center text-slate-600"
              data-testid="ai-bubble-close"
            >
              <X size={14} />
            </button>
          </div>
          <div className="flex-1 min-h-0">
            <AIAssistant compact showSidebar={false} />
          </div>
        </div>
      )}
    </>
  );
}
